import React from "react";
import Done from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';

const DoneIcon = ({ active }) => {
  return (
    <Done
      fontSize="small"
      sx={{
        color: "#fff",
        backgroundColor: active ? "#0091da" : "#9d9ea4",
        borderRadius: "100%",
        padding: "4px",
        width: "24px",
        height: "24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    />
  );
};

const FailedIcon = () => {
  return (
    <CloseIcon
      fontSize="small"
      sx={{
        color: "#fff",
        backgroundColor: "#be0712",
        borderRadius: "100%",
        padding: "4px",
        width: "24px",
        height: "24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    />
  );
};

const WarningIcon = () => {
  return (
    <PriorityHighIcon
      sx={{
        color: "#fff",
        backgroundColor: "#be0712",
        borderRadius: "100%",
        padding: "4px",
        width: "24px",
        height: "24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "16px"
      }}
    />
  );
};

export { DoneIcon, FailedIcon, WarningIcon };
